const Emoji_XYZ = {
    ':xmas': { id: 564, width: 21, height: 23 },
    ':yak': { id: 565, width: 20, height: 20 },
    ':yapyap': { id: 599, width: 36, height: 18 },
    ':yaright': { id: 10, width: 20, height: 20 },
    ':yawn': { id: 566, width: 18, height: 18 },
    ':yeahright': { id: 567, width: 20, height: 20 },
    ':yel': { id: 568, width: 40, height: 24 },
    ':yes': { id: 569, width: 20, height: 20 },
    ':yikes': { id: 570, width: 32, height: 33 },
    ':yinyang': { id: 571, width: 20, height: 20 },
    ':ymca': { id: 572, width: 18, height: 18 },
    ':yucky': { id: 573, width: 20, height: 20 },
    ':yuk1': { id: 574, width: 20, height: 20 },
    ':zip': { id: 575, width: 28, height: 28 },
    ':zippy': { id: 576, width: 18, height: 18 },
    ':zoo_cat': { id: 577, width: 29, height: 25 },
    ':zoo_donatello': { id: 578, width: 32, height: 31 },
    ':zoo_fox_1': { id: 579, width: 22, height: 21 },
    ':zoo_fox_2': { id: 580, width: 22, height: 21 },
    ':zoo_fox_3': { id: 581, width: 22, height: 21 },
    ':zoo_fox': { id: 583, width: 22, height: 21 },
    ':zoo_fox4': { id: 582, width: 22, height: 21 },
    ':zoo_homestar': { id: 584, width: 25, height: 24 },
    ':zoo_taz': { id: 585, width: 32, height: 32 },
    ':zorro': { id: 586, width: 26, height: 22 },
}

export default Emoji_XYZ
